import { SelectOption } from '@tmh-website/ui/FormElements';
import fuzzysort from 'fuzzysort';
import type { SearchResult as MinisearchSearchResult } from 'minisearch';

/**
 * Search inside components
 */

export enum Search {
  FuzzySort = 'FuzzySort',
}

export function searchSelectOptions(options: SelectOption[], search: string, type: Search) {
  switch (type) {
    case Search.FuzzySort: {
      return fuzzysort.go(search, options, { key: ['label'] }).map(result => result.obj);
    }
    default: {
      throw new Error(`Search type ${type} not supported`);
    }
  }
}

/**
 * Search through apis
 */

/**
 * @deprecated This should be removed once the new search is ready
 *
 * @see https://codetain.slack.com/archives/C06FJEJFCTT/p1713963831752419?thread_ts=1713961193.531299&cid=C06FJEJFCTT
 * @see https://mobilityhouse.atlassian.net/browse/WEBSITE23-76
 */
export enum SearchResultsMagentoTypeDeprecated {
  Product = 'product',
  Term = 'term',
  Category = 'category',
  CmsPage = 'cms_page',
  BlogPost = 'blog_post',
}

/**
 * @deprecated This should be removed once the new search is ready
 *
 * @see https://codetain.slack.com/archives/C06FJEJFCTT/p1713963831752419?thread_ts=1713961193.531299&cid=C06FJEJFCTT
 * @see https://mobilityhouse.atlassian.net/browse/WEBSITE23-76
 */
export interface SearchResultMagentoDeprecated {
  title: string;
  type: SearchResultsMagentoTypeDeprecated;
  num_results?: string;
  image?: string;
  url?: string;
  price?: string;
  breadcrumb?: string[];
}

export interface SearchResultProduct {
  uid: string;
  name: string;
  url: string;
}

/**
 * @deprecated This should be removed once the new search is ready
 */
export interface SearchResultProductDeprecated {
  type: SearchResultType.Product;
  title: string;
  url: string;
  image?: string;
  price: string;
}

export interface SearchResultTerm {
  type: SearchResultType.Term;
  title: string;
}

export interface SearchResultContent {
  type: SearchResultType.ContentPage | SearchResultType.KnowledgeCenter | SearchResultType.News | SearchResultType.Car;
  path: string;
  title: string;
  score: number;
}

export enum SearchResultType {
  ContentPage = 'ContentPage',
  KnowledgeCenter = 'KnowledgeCenter',
  News = 'News',
  Car = 'Car',
  Product = 'Product',
  Term = 'Term',
}

export type SearchResult = SearchResultProduct | SearchResultTerm | SearchResultContent;

export type SearchResultFilter =
  | SearchResultType.ContentPage
  | SearchResultType.KnowledgeCenter
  | SearchResultType.News
  | SearchResultType.Car
  | SearchResultType.Product;

export const searchResultFilterToTranslationMap: { [key in SearchResultFilter]: string } = {
  [SearchResultType.ContentPage]: 'global:search.type.contentPage',
  [SearchResultType.KnowledgeCenter]: 'global:search.type.knowledgeCenter',
  [SearchResultType.News]: 'global:search.type.news',
  [SearchResultType.Car]: 'global:search.type.car',
  [SearchResultType.Product]: 'global:search.type.product',
};

/**
 * @deprecated This should be removed once the new search is ready
 *
 * @see https://codetain.slack.com/archives/C06FJEJFCTT/p1713963831752419?thread_ts=1713961193.531299&cid=C06FJEJFCTT
 * @see https://mobilityhouse.atlassian.net/browse/WEBSITE23-76
 */
export const useDeprecatedSearch = ['development', 'staging'].includes(process.env.NEXT_PUBLIC_ENV!) === false;

export function highlightSearchResults(text: string, searchResult: MinisearchSearchResult) {
  searchResult.terms.forEach(term => {
    text = text.replace(new RegExp(term, 'ig'), match => `<span class="highlight">${match}</span>`);
  });
  return text;
}
